var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"cl-logo",attrs:{"src":_vm.centro_logo},on:{"error":function($event){_vm.failed = true}}})
}
var staticRenderFns = []

export { render, staticRenderFns }